import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { MatrixCriterion } from '../../../../types/advise';
import { COMING_SOON } from './MatrixAddControl';

const SUPPLIER_SUPPORT = 'support';

// Supplier Support keeps the story's exact wording; any other criterion without features gets the general sentence.
const calloutLead = ({ key, label, selected, weight }: MatrixCriterion) => {
  const share = selected
    ? `${label} carries ${weight ?? 0}% of the total score`
    : `${label} is cleared and carries no weight in the total score`;
  if (key !== SUPPLIER_SUPPORT) return `${share} but has no features behind it.`;
  return (
    `${share} but has no boolean feature list behind it in the current taxonomy — ` +
    "it's scored manually per supplier on the Supplier Scoring step (SLAs, responsiveness, market presence)."
  );
};

export const NoChecklistCallout = ({ criterion, canEdit }: { criterion: MatrixCriterion; canEdit: boolean }) => (
  <Alert
    severity="warning"
    className="mt-3">
    <AlertTitle>No feature checklist defined for this criterion</AlertTitle>
    {calloutLead(criterion)}
    {' Define a checklist here if this criterion should factor into feature coverage, ' +
      'or leave it manual-only and note that on Supplier Scoring.'}
    {canEdit && (
      <Box className="mt-1">
        <span title={COMING_SOON}>
          <Button
            size="small"
            disabled>
            Add Custom Feature
          </Button>
        </span>
      </Box>
    )}
  </Alert>
);
